/**
 * @desc Export table layout configuration.
 * @example
 * import { layoutConfig } from 'config/table-configs/action-list-notes';
 */
export const layoutConfig = {
    styles: {
        borderlessSearch: false,
    },
    dimensions: {
        maxHeight: 286,
        padding: 0,
    },
    columnWidth: {
        shortDescription: 120,
        description: 710
    }
};
